import React from 'react';
import { Link } from 'react-router-dom';
import { ChanelBanner } from '../../../../Shared/Content/ProductDetail/ChanelProductBanner/ChanelProductBanner';
import { MainImage } from '../../../../Shared/Content/ProductDetail/ProductMainImage/ProductMainImage';
import { AltImages, MainImageSlider } from '../../../../Shared/Content/ProductDetail/ProductAltImages/ProductAltImages';
import { ChanelTitle } from '../../../../Shared/Content/ProductDetail/ChanelProductTitle/ChanelProductTitle';
import { ProductReviewStars } from '../../../../Shared/Content/ProductDetail/ProductReviewStars/ProductReviewStars';
import { Price } from '../../../../../UI/Price/Price';
import ProductSocialMedia from '../../../../Shared/Content/ProductDetail/ProductSocialMedia/ProductSocialMedia';
import { ProductRecs } from '../../../../../UI/ProductRecs/ProductRecs';
import { ProductDetailReviews } from '../../../../Shared/Content/ProductDetail/ProductDetailReviews/ProductDetailReviews';
import { ProductDescription } from '../../../../Shared/Content/ProductDetail/ProductDescription/ProductDescription';
import { BrandDescription } from '../../../../Shared/Content/ProductDetail/BrandDescription/BrandDescription';
import { ChanelProductItemComponent } from '../../../../Shared/Content/ProductDetail/ChanelProductItemComponent/ChanelProductItemComponent';
import { AsNavFor } from '../../../../Mobile/Content/ProductDetail/ProductMainAndAltImages/ProductMainAndAltImages';
import { CloseXIcon } from '../../../../../UI/Icons/Icons';
import { PhotoSwipeZoom, MainImagePhotoSwipeZoom } from '../PhotoSwipeZoom/PhotoSwipeZoom';
import AfterPayMessaging from '../../../../Shared/Content/ProductDetail/AfterPayMessaging/AfterPayMessaging';
import ProductMisc from '../../../../Shared/Content/ProductDetail/ProductMisc/ProductMisc';
import WcPowerPage from '../../../../Shared/Content/ProductDetail/ProductDisplay/WcPowerPage';

export class ProductItemDisplayChanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      deviceWidth: 770,
      isOpen: false,
      options: {
        showHideOpacity: true,
        allowPanToNext: true,
        maxSpreadZoom: 3,
        closeOnVerticalDrag: true,
        focus: true,
      },
    };

    this.zoomIndex = 0;
  }

  openPhotoSwipe = (e) => {
    e.preventDefault();
    this.setState({
      isOpen: true,
      options: {
        index: this.zoomIndex,
        closeOnScroll: false,
      },
    });
  };

  handleClose = () => {
    this.setState({
      isOpen: false,
    });
  };

  openPhotoSwipeMain = (e) => {
    let dataKey = parseInt(e.target.getAttribute('data-key'));
    this.setState({
      isOpen: true,
      options: {
        index: dataKey,
        closeOnScroll: false,
      },
    });
  };

  updateZoomIndex = (i) => {
    this.zoomIndex = i;
  };

  render() {
    var settings = {
      containsAlts: this.props.contentData.altImages ? true : false,
    };

    return (
      <section id='ProductItemDisplayChanel'>
        <PhotoSwipeZoom
          isOpen={this.state.isOpen}
          options={this.state.options}
          handleClose={this.handleClose}
          passedFunctions={this.props.passedFunctions}
          contentData={this.props.contentData}
          selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
          updateZoomIndex={this.updateZoomIndex}
        />
        <div className={`${this.props.passedFunctions.parentState.imageClickedOn ? 'hidden' : ''}`}>
          <ChanelBanner />

          <div className='row'>
            <div className='col-md-12 col-lg-10 '>
              <div className='row'>
                {this.state.deviceWidth > 769 && this.props.passedAppFunctions.siteFormat != 'tablet' ? (
                  <div className={`${settings.containsAlts ? 'col-sm-1' : 'col-sm-0'} p-0 altCol`}>
                    <AltImages
                      contentData={this.props.contentData}
                      passedFunctions={this.props.passedFunctions}
                      selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                      selectedAttributeValue={this.props.passedFunctions.parentState.selectedAttributeValue}
                      passedAppFunctions={this.props.passedAppFunctions}
                      altClicked={this.props.altClicked}
                    />
                  </div>
                ) : (
                  ''
                )}
                <PhotoSwipeZoom
                  isOpen={this.state.isOpen}
                  options={this.state.options}
                  passedFunctions={this.props.passedFunctions}
                  handleClose={this.handleClose}
                  contentData={this.props.contentData}
                  selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                  updateZoomIndex={this.updateZoomIndex}
                />
                <div className='col-6'>
                  {(this.props.passedAppFunctions.siteFormat == 'desktop' || !this.props.contentData.altImages) && (
                    <MainImage
                      passedFunctions={this.props.passedFunctions}
                      passedAppFunctions={this.props.passedAppFunctions}
                      contentData={this.props.contentData}
                      selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                      openPhotoSwipe={this.openPhotoSwipe}
                      swatchGroups={this.props.passedFunctions.parentState.swatchGroups}
                    />
                  )}
                  {this.props.passedAppFunctions.siteFormat != 'desktop' && this.props.contentData.altImages && (
                    <>
                      <MainImagePhotoSwipeZoom
                        isOpen={this.state.isOpen}
                        options={this.state.options}
                        handleClose={this.handleClose}
                        passedFunctions={this.props.passedFunctions}
                        contentData={this.props.contentData}
                        selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                        updateZoomIndex={this.updateZoomIndex}
                      />
                      <MainImageSlider
                        contentData={this.props.contentData}
                        passedFunctions={this.props.passedFunctions}
                        passedAppFunctions={this.props.passedAppFunctions}
                        selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                        openPhotoSwipeMain={this.openPhotoSwipeMain}
                        altClicked={this.state.altClicked}
                        altIndex={this.state.altIndex}
                      />
                      <div className='dds-stylitics-jumplink-wrapper'>
                        <a
                          href='#dds-stylitics-widget-title'
                          className='dds-stylitics-jumplink'
                          id='stylitics-jumplink'
                        >
                          How To Style
                        </a>
                      </div>
                    </>
                  )}
                  {this.props.passedAppFunctions.siteFormat == 'tablet' ? (
                    <span className='tapToZoom'>Tap image to zoom</span>
                  ) : (
                    ''
                  )}
                  {this.state.deviceWidth < 769 || this.props.passedAppFunctions.siteFormat == 'tablet' ? (
                    //Alts displayed below MainImage for tablet.
                    <AltImages
                      contentData={this.props.contentData}
                      passedFunctions={this.props.passedFunctions}
                      passedAppFunctions={this.props.passedAppFunctions}
                      selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                      selectedAttributeValue={this.props.passedFunctions.parentState.selectedAttributeValue}
                      vertical={false}
                      altClicked={this.props.altClicked}
                    />
                  ) : (
                    ''
                  )}
                </div>
                <div className='col-md-6 col-lg-5'>
                  <ChanelTitle contentData={this.props.contentData} />
                  <ProductReviewStars
                    passedFunctions={this.props.passedFunctions}
                    passedAppFunctions={this.props.passedAppFunctions}
                    contentData={this.props.contentData}
                  />
                  <Price pricing={this.props.contentData.pricing} />
                  <ProductDescription
                    open={true}
                    contentData={this.props.contentData}
                    passedAppFunctions={this.props.passedAppFunctions}
                  />
                  <BrandDescription
                    open={false}
                    contentData={this.props.contentData}
                    passedAppFunctions={this.props.passedAppFunctions}
                  />
                  <ProductMisc
                    contentData={this.props.contentData}
                    passedFunctions={this.props.passedFunctions}
                    passedAppFunctions={this.props.passedAppFunctions}
                  />
                  <ProductSocialMedia
                    contentData={this.props.contentData}
                    passedFunctions={this.props.passedFunctions}
                  />
                </div>
              </div>
              <div className='chanelItem'>
                {this.props.contentData.isInternational == 'Y' || !this.props.passedAppFunctions.isInternational() ? (
                  <ChanelProductItemComponent
                    currentAttributeState={this.props.currentAttributeState}
                    contentData={this.props.contentData}
                    passedFunctions={this.props.passedFunctions}
                    passedAppFunctions={this.props.passedAppFunctions}
                  />
                ) : (
                  <div id='error-message' className='alert alert-danger' role='alert'>
                    This item is not available for international purchase.
                  </div>
                )}
              </div>
            </div>
            <div className='col-2 productRecsColumn'>
              <ProductRecs
                zoneName='PDPZ1'
                contentData={this.props.contentData}
                vertical={true}
                passedAppFunctions={this.props.passedAppFunctions}
              />
            </div>
          </div>
          <div id='bottom-chanel-banner' className='row'>
            <div id='chanel-e-logo-image-container'>
              <img
                id='chanel-e-logo'
                src={'/assets/img/chanel-e-logo.png'}
                height='140'
                width='140'
                alt={'chanel authorized retailer'}
              />
            </div>
          </div>
          <ProductDetailReviews
            contentData={this.props.contentData}
            passedAppFunctions={this.props.passedAppFunctions}
            passedFunctions={this.props.passedFunctions}
          />
        </div>
        <WcPowerPage {...this.props} />
      </section>
    );
  }
}

export default ProductItemDisplayChanel;
